import {
  resolveSearchHitIsTyomarkkinatori,
  TYOMARKKINATORI_LOGO_PATH,
} from './resolve-search-hit-is-tyomarkkinatori';

/**
 * Company key for hosted logo paths, filters, and profile links on SRP hits.
 * Prefers `companyId`; falls back to `companyName` when Typesense strips the id.
 */
export function resolveSearchHitCompanyId(hit: Record<string, unknown>): string {
  const companyId = typeof hit.companyId === 'string' ? hit.companyId.trim() : '';
  if (companyId) return companyId;

  const companyName = typeof hit.companyName === 'string' ? hit.companyName.trim() : '';
  return companyName;
}

/**
 * Direct logo URL from the search index (external CDN or site-relative path).
 * Returns Työmarkkinatori mark when applicable; otherwise uses `logoUrl` when valid.
 */
export function resolveSearchHitHostedLogoUrl(hit: Record<string, unknown>): string | undefined {
  if (resolveSearchHitIsTyomarkkinatori(hit)) {
    return TYOMARKKINATORI_LOGO_PATH;
  }

  const logoUrl = typeof hit.logoUrl === 'string' ? hit.logoUrl.trim() : '';
  if (!logoUrl) return undefined;

  if (
    logoUrl.startsWith('http://') ||
    logoUrl.startsWith('https://') ||
    logoUrl.startsWith('/')
  ) {
    return logoUrl;
  }

  return undefined;
}
